import {UNIT_TYPE} from "../../unit/support/UnitType";
import React from "react";

export const UnitsContainerHeader = ({units}) => {
  return (
      <div className="flex justify-between items-center">
        <h3 className="text-xl font-semibold">Wohn- und Gewerbeeinheiten</h3>
        <div className="text-sm text-gray-600">
          Gesamt: {units.filter(u => u.unit_type
            === UNIT_TYPE.LIVING.value).length} WE, {units.filter(
            u => u.unit_type === UNIT_TYPE.COMMERCIAL_GENERAL.value).length} GE
        </div>
      </div>
  );
}